import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { observable, Subscription, of as observableOf, Observable } from 'rxjs';

import {
    IntralinksContentContainerConfig, IntralinksContentContainerAction,
    IntralinksContentContainerActionType, IntralinksContentContainerReloadAction, IntralinksContentType
} from './intralinks-content-container.model';
import { IntralinksFile } from '../../tamalelibs/models/intralinks.model';
import { IntralinksGroupContainerConfig } from '../intralinks-group/intralinks-group.model';
import { IntralinksValidationService } from './../intralinks-validation/intralinks-validation.service';
import { map, mergeMap, take } from 'rxjs/operators';

@Component({
    selector: 'tam-intralinks-content-container',
    templateUrl: './intralinks-content-container.component.html',
    styleUrls: ['./intralinks-content-container.component.scss']
}

) export class IntralinksContentContainerComponent implements OnInit, OnDestroy {

    @Input() config: IntralinksContentContainerConfig;
    contentType = '';
    files: IntralinksFile[];
    groupConfig: IntralinksGroupContainerConfig;
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _validationService: IntralinksValidationService
    ) { }

    ngOnInit() {
        this._destroySubscriptions.push(this.config.actionSubject$.subscribe((action: IntralinksContentContainerAction) => {
            if (action.type === IntralinksContentContainerActionType.RELOAD) {
                this._onReload(action as IntralinksContentContainerReloadAction);
            }
        }));

    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(subscription => {
            if (subscription && !subscription.closed) {
                subscription.unsubscribe();
            }
        });
    }

    private _onReload(action: IntralinksContentContainerReloadAction): void {
        this.initConfigs();
        this.contentType = action.payload.contentType;
        switch (action.payload.contentType) {
            case IntralinksContentType.FOLDER: {
                const files = action.payload.config;
                if (files && files.length > 0) {
                    this._validationService.validate(action.screenId, action.workspaceId).pipe(take(1)).subscribe((result) => {
                        if (result) {
                            this.files = action.payload.config;
                        }
                    });
                } else {
                    this.files = [];
                }
                break;
            }
            case IntralinksContentType.GROUP: {
                if (action.workspaceId) {
                    this._validationService.validate(action.screenId, action.workspaceId).pipe(take(1)).subscribe((result) => {
                        if (result === true) {
                            this.groupConfig = action.payload.config;
                        }
                    });
                } else if (Array.isArray(action.workspaceIds)) {
                    this.validateWorkspaceSequencial(action.screenId, action.workspaceIds).pipe(take(1)).subscribe((result) => {
                        if (result === true) {
                            this.groupConfig = action.payload.config;
                        }
                    });
                }
                break;
            }
        }
    }

    private validateWorkspaceSequencial(screenId: string, workspaceIds: string[]): Observable<any> {
        if (workspaceIds && workspaceIds.length > 0) {
            const workspaceId =
                workspaceIds.shift();
            return this._validationService.validate(screenId, workspaceId).pipe(take(1), mergeMap(
                (result) => {
                    if (result) {
                        return this.validateWorkspaceSequencial(screenId, workspaceIds);
                    } else {
                        return observableOf(false);
                    }
                }
            ));
        } else {
            return observableOf(true);
        }
    }

    private initConfigs() {
        this.contentType = '';
        this.files = [];
        this.groupConfig = null;
    }

}
